import React from "react";
import { useNavigate } from "react-router-dom";
import Recorder from "../../QuestionPage/recorder";
import { useState, useEffect } from "react";

// Fetching Data from the API]

// End

// Page Html
export default function ReadAloudPage(props) {
  
  const { question, onInputChange ,questionNumber} = props;

  const navigate = useNavigate();
  const [text, setText] = useState("");


  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;
  console.log("Mock Dec:", mockData)

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };
  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
          
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of 36
        </h2>
        <p className="p-2">
          Look at the text below. In the 35 seconds, you must read this text
          aloud as naturally and clearly as possible. You have 35 seconds to
          read aloud.
        </p>

        <Recorder
              text={text}
              setText={handleTextChange}
              {...props}
              duration={20}
              className="relative left-[450px] ml-6 mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
            />
        <p className="p-2">
        {mockData.question}
        </p>
      </div>
    </div>
  );
}
